/**
 * Ref-counted page scroll lock shared by all backdrop overlays
 * (Modal, Drawer, BottomSheet, SideSheet, ImageGallery, Dialog).
 *
 * Each overlay calls lockBodyScroll() when it opens and unlockBodyScroll()
 * when it closes. The page is locked while at least one overlay is open and
 * only restored once the LAST one closes — so a closing/closed overlay can no
 * longer clobber the scroll lock of one that is still open.
 *
 * NOTE: this app sets `overflow-x: hidden` on <html> (globals.css). Once the
 * root element has a non-visible overflow, the <body>'s overflow no longer
 * propagates to the viewport, so the page actually scrolls on <html>
 * (documentElement). We therefore lock BOTH <html> and <body> to be robust.
 */

let lockCount = 0;
let saved: { html: string; body: string } | null = null;

export function lockBodyScroll(): void {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) {
    const html = document.documentElement;
    const body = document.body;
    saved = { html: html.style.overflow, body: body.style.overflow };
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
  }
  lockCount += 1;
}

export function unlockBodyScroll(): void {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0 && saved) {
    document.documentElement.style.overflow = saved.html;
    document.body.style.overflow = saved.body;
    saved = null;
  }
}
